import DocumentTemplate from "./DocumentTemplate";
import Organization from "./Organization";
import Package from "./Package";
import SignatoryGroup from "./SignatoryGroup";
import User from "./User";

export enum TargetAudience {
  STAFF = "staff",
  PARENTS = "parents",
}

export type CampaignPackageWrapper =
  | { type: 'package'; value: Package }
  | { type: 'template'; value: DocumentTemplate };

export type Campaign = {
  id?: string;
  name: string;
  description: string;
  package: Package | undefined;
  packageWrapper?: CampaignPackageWrapper;
  signaturePositionFile?: string;
  signatoryGroup: SignatoryGroup | undefined;
  organization: Organization | undefined;
  status: string;
  actions?: string;
  schedule: boolean;
  startDate: Date;
  endDate: Date;
  targetAudience?: TargetAudience;
  language?: string;
  creationTime?: Date;
  sentTime?: Date;
  modifyingUser: User | undefined;
  emailSubject: string;
  emailMessage: string;
  scheduledDateTime?: Date;
  paymentEnabled?: boolean;
  paymentName?: string;
  payment?: string;
  attachments?: string;
  internalStaffFlow?: boolean;
};

export default Campaign;
